import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatePipe } from './date.pipe';
import { FormatAssessmentDatePipe } from './format-assessment-date.pipe';

@NgModule({
    declarations: [DatePipe, FormatAssessmentDatePipe],
    imports: [CommonModule],
    exports: [DatePipe, FormatAssessmentDatePipe]
})
export class DatePipeModule {}
